module.exports = __webpack_public_path__ + "static/media/2.96e23d0e.jpg";